import { render, staticRenderFns } from "./IngredientsBalance.vue?vue&type=template&id=2cc41134&scoped=true&"
import script from "./IngredientsBalance.vue?vue&type=script&lang=js&"
export * from "./IngredientsBalance.vue?vue&type=script&lang=js&"
import style0 from "./IngredientsBalance.vue?vue&type=style&index=0&id=2cc41134&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc41134",
  null
  
)

export default component.exports